import { z } from 'zod';

import { PaginationSchema } from '../../../pagination.js';

import { WorkshopTaxonomyOriginSchema } from './manufacturer.schemas.js';

const WorkshopTaxonomyListQuerySchema = PaginationSchema.extend({
  q: z.string().trim().min(2).optional(),
  limit: z.coerce.number().int().min(1).max(500).default(20),
});

const measurementUnitCode = z
  .string()
  .trim()
  .min(1)
  .max(10)
  .regex(/^[A-Z0-9_]{1,10}$/);

export const RegisterMeasurementUnitBodySchema = z.object({
  name: z.string().trim().min(1).max(255),
  code: measurementUnitCode,
  fiscalUnitCode: z.string().trim().max(20).nullable().optional(),
});

export const RegisterMeasurementUnitResponseSchema = z.object({
  measurementUnitId: z.uuid(),
});

export const UpdateMeasurementUnitBodySchema = z
  .object({
    name: z.string().trim().min(1).max(255).optional(),
    fiscalUnitCode: z.string().trim().max(20).nullable().optional(),
  })
  .refine((body) => Object.keys(body).length > 0, { message: 'At least one field is required' });

export const ArchiveMeasurementUnitBodySchema = z.object({
  reason: z.string().trim().max(500).optional(),
});

export const ListMeasurementUnitsQuerySchema = WorkshopTaxonomyListQuerySchema;

export const MeasurementUnitListItemSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  code: z.string(),
  fiscalUnitCode: z.string().nullable(),
  origin: WorkshopTaxonomyOriginSchema,
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const ListMeasurementUnitsResponseSchema = z.object({
  items: z.array(MeasurementUnitListItemSchema),
  pagination: z.object({
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type RegisterMeasurementUnitBody = z.infer<typeof RegisterMeasurementUnitBodySchema>;
export type RegisterMeasurementUnitResponse = z.infer<typeof RegisterMeasurementUnitResponseSchema>;
export type UpdateMeasurementUnitBody = z.infer<typeof UpdateMeasurementUnitBodySchema>;
export type ArchiveMeasurementUnitBody = z.infer<typeof ArchiveMeasurementUnitBodySchema>;
export type ListMeasurementUnitsQuery = z.infer<typeof ListMeasurementUnitsQuerySchema>;
export type ListMeasurementUnitsResponse = z.infer<typeof ListMeasurementUnitsResponseSchema>;
